import { DateTime } from "luxon"

// Constant for Zurich timezone
const TIMEZONE = "Europe/Zurich"

export const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
};

export const formatTimeHHmm = (date: Date) => {
    return DateTime.fromJSDate(date).setZone(TIMEZONE).toFormat('HH:mm')
}